<template>
  <CockpitDialog class="cameraPicture" title="监控画面" @close="close">
    <HKPlayer
      class="w-full h-full"
      :codeData="codeData"
      :showControlling="showControlPanel"
      :playerConfig="playerConfig"
    ></HKPlayer>
  </CockpitDialog>
</template>

<script>
import HKPlayer from '../video/HKPlayer/index'

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
export default {
  name: 'cameraPicture',
  props: {
    deviceCode: {
      type: String,
      default: '',
    },
    plid: {
      type: String,
      default: '',
    },
    // 是否显示云台操作
    showControlPanel: {
      type: Boolean,
      default: true,
    },
    // 摄像头编码
    code: {
      type: String,
      defalut: '',
    },
  },
  components: {
    CockpitDialog,
    HKPlayer,
  },
  watch: {
    code: {
      immediate: true,
      handler(val) {
        this.codeData.code = val
        this.getProtocol()
      },
    },
  },
  data() {
    return {
      playerConfig: {
        streamType: 0, // 码流类型：0-主码流，1-子码流，2-第三码流，默认0
        protocol: '', // 取流协议('hik, rtsp, rtmp, hls')，默认hik
        transmode: 1, // 传输协议，0-UDP, 1-TCP, 默认TCP
        recordLocation: 1, // 存储类型：0-中心存储，1-设备存储，默认0
      },
      codeData: {
        code: '',
        id: 'hikplayer',
      },
    }
  },
  methods: {
    close() {
      this.$emit('refresh', false)
    },
    // 获取使用协议
    getProtocol() {
      const protocol = window.location.protocol
      if (protocol === 'https:') {
        this.playerConfig.protocol = 'wss'
      } else if (protocol === 'http:') {
        this.playerConfig.protocol = 'ws'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.cameraPicture {
  left: 520px;
  top: 200px;
}
.cameraBox {
  height: calc(100% - 50px);
  .toolBox {
    color: #ffffff99;
    font-family: Microsoft YaHei UI;
    font-weight: regular;
    font-size: 20px;
    line-height: normal;
    letter-spacing: 0px;
    text-align: left;
    .direction {
      border-radius: 50%;
      border: 1.93px solid #d9d9d94c;
    }
  }
}
</style>
